import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import { bindActionCreators, Dispatch } from 'redux';
import { transitDeleteComment } from 'services/transits';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { PortType, RootState } from 'types';
import { FavouritControlsInterface, VoidInterface } from 'types/functions';
import { FilterObjectType } from 'types/search';
import { formatServerErrors } from 'utils/formatServerErrors';
import { translate } from 'utils/translate';

interface UserDeleteCommentModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    id?: string;
    data: any;
    actions: { onCancel: VoidInterface; onConfirm: (id: string) => void } | undefined;

    //unused props
    highlightObject: FilterObjectType;

    //unused props
    searchObject: FilterObjectType;

    //unused props
    favouritControls: FavouritControlsInterface;

    //unused props
    port: PortType;

    setErrorHandlerAction: SetErrorHandlerAction;
}

interface UserDeleteCommentModelState {
    errors: object;
    data: any | null;
    loading: boolean;

    //unused state
    overwite: boolean;
}

class UserDeleteCommentModel extends Component<UserDeleteCommentModelProps, UserDeleteCommentModelState> {
    constructor(props: UserDeleteCommentModelProps) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            loading: false,
            overwite: false,
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.setState({ errors: {}, loading: true }, () => {
            transitDeleteComment(this.props.port.id, this.props.data.id)
                .then(() => {
                    this.props.actions?.onConfirm(this.props.data.id);
                    this.props.actions?.onCancel();
                })
                .catch((errors) => {
                    switch (errors.response?.status) {
                        case 422:
                            this.setState({ errors: formatServerErrors(errors), loading: false });
                            break;
                        default:
                            this.setState({ loading: false });
                            this.props.setErrorHandlerAction(errors);
                            break;
                    }

                    return;
                });
        });
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Delete this commment')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <div className="mt-5 flex items-center gap-1 text-gray-800">
                        {translate('Are you sure to delete this comment ?')}
                    </div>

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button
                                disabled={this.state.loading}
                                loading={this.state.loading}
                                type="submit"
                                className="px-4 py-2 bg-primary-delete rounded-md text-white"
                            >
                                {translate('Delete')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    port: state.port.port,
    searchObject: state.layout.searchObject,
    highlightObject: state.layout.highlightObject,
    favouritControls: state.layout.favouritControls,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDeleteCommentModel);
